module.exports = __webpack_public_path__ + "img/about_b_img1.6dccf592.jpg";